import { Adapter as o, getAdapter as r } from "../../../../adapter.js";
import { ShopSessionDeliveryModel as p } from "./delivery.model.js";
import { ShopSessionDropOffAdapter as t } from "./dropOff/dropOff.adapter.js";
class f extends o {
  adapt(e) {
    return new p({
      dropOff: r(t).adapt(e.drop_off)
    });
  }
  serialize(e) {
  }
}
export {
  f as ShopSessionDeliveryAdapter
};
//# sourceMappingURL=delivery.adapter.js.map
